import React from 'react';
import Typography from './Typography';

const steps = [
    'Select Investment',
    'Promissory note',
    'Contract Signing',
    'Wire Transfer',
];

const CustomStepper = ({ currentStep }) => {
    return (<>
        <div className="flex items-start justify-between w-full lg:max-w-4xl md:max-w-xl max-w-[329px] mx-auto h-[150px] px-4 py-6">
            {steps.map((label, index) => {
                const isCompleted = index + 1 < currentStep;
                const isActive = index + 1 === currentStep;
                // const isUpcoming = index + 1 > currentStep;

                return (
                    <React.Fragment key={label}>
                        {index !== 0 && (
                            <div
                                className={`w-full relative top-[22px] h-0.5 ${(isCompleted || isActive) ? 'bg-[#DF0F11]' : 'bg-gray-600'
                                    } z-10`}
                            />
                        )}
                        <div key={index} className="flex-1 flex flex-col justify-center items-center relative">
                            {/* Connector line */}


                            {/* Step circle */}
                            <div
                                className={`w-[46px] h-[46px] rounded-full relative flex items-center justify-center z-20
                ${isCompleted || (isActive && index === 0)
                                        ? 'border-2 border-[#DF0F11] text-[#DF0F11] bg-transparent'
                                        : isActive && index !== 0
                                            ? 'bg-[#DF0F11] text-white'
                                            : 'border-2 border-gray-500 text-white opacity-60 bg-transparent'
                                    }`}
                            >
                                <Typography text={index + 1} size={'20px'} family={'Supply'} weight={400} lineheight={'170%'} />
                            </div>
                            {/* Label */}
                            <div
                                className={`text-center absolute md:min-w-44 min-w-20 top-[60px]
              ${isCompleted || (isActive && index === 0)
                                        ? 'text-[#DF0F11]'
                                        : isActive
                                            ? 'text-white'
                                            : 'text-gray-500'
                                    }`}
                            >
                                <Typography text={label} className='sm:block hidden' size={'18px'} weight={400} lineheight={'32px'} />
                                <Typography text={label} className='sm:hidden block' size={'12px'} weight={400} lineheight={'15px'} />
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    </>);
};

export default CustomStepper;
